import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import { ModalButtonSave, ModalButtonUpdate, } from '../../constant';
import { Button } from 'reactstrap';
import { FormMicUnits } from './FormMicUnits';
import { Dialog } from 'primereact/dialog';

export const ModalMicUnits = (props) => {

    const {
        modal, modalTitle, toggle, method, loading,
        unit, abbreviation, handleInputChange,
        validaciones, saveCreate, saveUpdate, saveDelete,
        closeDialog
    } = props;

    return (
        <Dialog
            visible={modal}
            onHide={closeDialog}
            closable={false}
            modal
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="icofont icofont-table f-24"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v38 `}
            footer={
                <>
                    {
                        method === "create" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveCreate}
                        >
                            {
                                loading ? "Creando...." : "Crear"
                            }
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveUpdate}
                        >
                            {
                                loading ? "Actualizando...." : "Actualizar"
                            }
                        </Button>
                    }
                    <Button
                        size="sm"
                        color='danger'
                        type="button"
                        onClick={closeDialog}>
                        Cancelar
                    </Button>
                </>
            }
        >

            {
                method === "create"
                    ?
                    < FormMicUnits
                        button={ModalButtonSave}
                        {...{ closeDialog, loading, handleInputChange, validaciones, methodAction: saveCreate }}
                    />
                    :
                    (method === "update")
                        ?
                        < FormMicUnits
                            button={ModalButtonUpdate}
                            {...{ closeDialog, loading, handleInputChange, validaciones, methodAction: saveUpdate, unit, abbreviation, }}
                        />
                        : null
            }
        </Dialog>
    )
}
